'use client';

import type { SourceType, VerificationStatus } from '@/types/firestore';
import { getAuthorityBadgeInfo, SOURCE_TYPE_LABEL, VERIFICATION_LABEL } from '@/lib/constants';

interface SourceBadgeProps {
  authorityTier?: number;
  sourceType?: SourceType;
  verificationStatus?: VerificationStatus;
  size?: 'sm' | 'md';
}

export default function SourceBadge({ authorityTier, sourceType, verificationStatus, size = 'sm' }: SourceBadgeProps) {
  // sourceType이 없으면 기존 문서이므로 배지 표시 안 함
  if (!sourceType) return null;

  const badge = getAuthorityBadgeInfo(authorityTier, sourceType);

  if (size === 'sm') {
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold border ${badge.colorClass}`}>
        <span>{badge.icon}</span>
        <span>{badge.label}</span>
      </span>
    );
  }

  // md: 상세 페이지용 — 신뢰등급 + 출처종류 + 검증 상태
  return (
    <div className="flex flex-wrap items-center gap-2">
      {/* 신뢰등급 배지 */}
      <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold border ${badge.colorClass}`}>
        <span>{badge.icon}</span>
        <span>{badge.label}</span>
      </span>
      {/* 출처종류 배지 */}
      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-50 text-gray-600 border border-gray-200">
        {SOURCE_TYPE_LABEL[sourceType]}
      </span>
      {/* 검증 상태 */}
      {verificationStatus && verificationStatus !== 'unverified' && (
        <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold ${VERIFICATION_LABEL[verificationStatus]?.colorClass || ''}`}>
          {VERIFICATION_LABEL[verificationStatus]?.label}
        </span>
      )}
    </div>
  );
}
